import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/feed';

const stats = [
  { value: '342', label: '本周追踪话题' },
  { value: '5', label: '值夜时段分档' },
  { value: '1,286', label: '夜间更新条目' },
];

const slotByHour = (hour: number) => {
  if (hour >= 0 && hour < 3) return '午夜档';
  if (hour >= 3 && hour < 5) return '凌晨档';
  if (hour >= 5 && hour < 7) return '后半夜';
  if (hour >= 23) return '午夜档';
  return '通宵场';
};

export default function HeroSection() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  const clock = now.toLocaleTimeString('zh-CN', { hour12: false });
  const pad = (n: number) => String(n).padStart(2, '0');
  const dateText = `${now.getFullYear()}.${pad(now.getMonth() + 1)}.${pad(now.getDate())}`;
  const slot = slotByHour(now.getHours());

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20night%20city%20skyline%20at%20two%20am%20with%20warm%20amber%20and%20crimson%20neon%20glow%2C%20low%20fog%2C%20deep%20shadows%2C%20moody%20atmospheric%20abstract%20urban%20photography&width=1600&height=900&seq=nightgossip-hero-01&orientation=landscape"
          alt="深夜城市夜景，暖色灯光在雾气中晕开"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/80 to-background-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/40 to-transparent" />
      </div>

      <div className="relative mx-auto flex w-full max-w-[1440px] flex-col px-4 pt-32 pb-14 md:px-8 md:pt-40 md:pb-20">
        <div className="w-full max-w-3xl animate-rise">
          <div className="mb-6 flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-3 py-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-400 animate-pulse-dot" />
              <span className="font-label text-xs tracking-widest text-primary-300">值夜编辑在岗</span>
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100/70 px-3 py-1.5 font-label text-xs text-foreground-700">
              <i className="ri-time-line" />
              {dateText} {clock}
              <span className="text-foreground-400">·</span>
              <span className="text-accent-300">当前 {slot}</span>
            </span>
          </div>

          <h1 className="font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl lg:text-[56px]">
            {siteInfo.name}
            <span className="mt-3 block text-xl font-semibold text-foreground-700 md:mt-4 md:text-3xl">
              {siteInfo.slogan}
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {siteInfo.desc}
            午夜、凌晨、后半夜三个时段分开盯，谁的话题在升温、哪里出现了反转、哪条消息其实只是转述，我们都按时间线记下来。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/feed"
              className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 font-label text-sm text-white transition-colors hover:bg-primary-600"
            >
              <i className="ri-flashlight-line" />
              进入瓜田情报库
            </Link>
            <Link
              to="/#subscribe"
              className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 font-label text-sm text-foreground-900 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              <i className="ri-mail-send-line" />
              订阅深夜整理
            </Link>
          </div>

          <dl className="mt-12 grid max-w-xl grid-cols-1 gap-4 border-t border-background-200/70 pt-6 sm:grid-cols-3">
            {stats.map((s) => (
              <div key={s.label}>
                <dt className="font-display text-3xl tracking-wide text-accent-400">{s.value}</dt>
                <dd className="mt-1 text-xs text-foreground-600">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}